<div class="card card-custom">
	<div class="card-header" style="justify-content: flex-start">
		<div class="card-title">Transporte - Exportación</div>
		<div class="row">
                <div class="col-12">
                    <div class="form-group mt-5 pt-3 ml-5">
                        <div class="col-1 ml-5 text-center pr-1">
                            <div class="row">
                                <input type="checkbox" class="form-check-input mr-5" (change)="changeLocalService($event)" >

                            </div>
                        </div>
                        <div class="label-control float-left pl-3 ml-3" ngbTooltip="Indica si el documento no considera datos de transporte internacional">Servicio Local</div>
                    </div>
                </div>
            </div>
	</div>
	<div class="card-content">
		<div class="card-body" [formGroup]="exportFormGroup" #localForm="ngForm">
			<div class="row">
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Flete</div>
						<div class="col-8">
							<input formControlName="flete" type="number" class="form-control" (change)="onSubmit()" />
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.flete.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.flete.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Seguro</div>
						<div class="col-8">
							<input formControlName="seguro" type="number" class="form-control" (blur)="onSubmit()" />
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.seguro.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.seguro.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Vía de Transporte</div>
						<div class="col-8">
							<ng-select formControlName="viaTransporte" [items]="viaTransporteSource" [multiple]="false" [clearable]="false" (blur)="onSubmit()" bindLabel="descripcion"></ng-select>
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.viaTransporte.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.viaTransporte.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Pais Receptor y Destino</div>
						<div class="col-8">
							<ng-select formControlName="paisReceptor" [items]="paisesSource" [multiple]="false" [clearable]="false" (blur)="filterPortBySelectedCountry()" bindLabel="nombre"></ng-select>
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.paisReceptor.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.paisReceptor.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Puerto de Embarque</div>
						<div class="col-8">
							<ng-select formControlName="puertoEmbarque" [items]="selectionEmbarqueSource" [clearable]="false" (blur)="onSubmit()" bindLabel="nombrePuerto"> </ng-select>
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.puertoEmbarque.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.puertoEmbarque.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Puerto De Desembarque</div>
						<div class="col-8">
							<ng-select formControlName="puertoDesembarque" [items]="selectionDesembarqueSource" [clearable]="false" (blur)="onSubmit()" bindLabel="nombrePuerto" notFoundText="País sin puertos"></ng-select>
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.puertoDesembarque.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.puertoDesembarque.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Tara</div>
						<div class="col-8">
							<input formControlName="tara" type="text" class="form-control" (blur)="onSubmit()" />
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.tara.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.tara.errors?.required">Campo Requerido</div>
								<div *ngIf="exportFormGroup.controls.tara.errors?.pattern">Solo ingrese valores enteros</div>
							</div>
							<div *ngIf="(localForm.touched || localForm.dirty) && !isLocalService && exportFormGroup.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.errors?.greaterNet">Peso Neto y Tara deben ser menores a Peso Bruto</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Unidad de Medida Tara</div>
						<div class="col-8">
							<ng-select formControlName="medidaTara" [items]="unidadesMedidaSource" [multiple]="false" [clearable]="false" (blur)="onSubmit()" bindLabel="nombreUnidadMedida"></ng-select>
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.medidaTara.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.medidaTara.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Unidad de Medida Peso</div>
						<div class="col-8">
							<!-- <input formControlName="medidaPesoNeto" type="text" class="form-control"> -->
							<ng-select formControlName="medidaPesoNeto" [items]="unidadesMedidaSource" [clearable]="false" (blur)="onSubmit()" bindLabel="nombreUnidadMedida"></ng-select>
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.medidaPesoNeto.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.medidaPesoNeto.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Peso Neto</div>
						<div class="col-8">
							<input formControlName="pesoNeto" type="number" class="form-control" (blur)="onSubmit()" />
							<div *ngIf="(localForm.touched || localForm.dirty) && !isLocalService && exportFormGroup.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.errors?.greaterNet">Peso Neto y Tara deben ser menores a Peso Bruto</div>
							</div>
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.pesoNeto.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.pesoNeto.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Peso Bruto</div>
						<div class="col-8">
							<input formControlName="pesoBruto" type="number" class="form-control" (blur)="onSubmit()" />
							<div *ngIf="(localForm.touched || localForm.dirty) && !isLocalService && exportFormGroup.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.errors?.greaterNet">Peso Neto y Tara deben ser menores a Peso Bruto</div>
							</div>
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.pesoBruto.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.pesoBruto.errors?.required">Campo Requerido</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6 form-group mx-auto">
					<div class="row">
						<div class="col-4 label-control">Total de Bultos</div>
						<div class="col-8">
							<input formControlName="totalBultos" type="number" class="form-control" (blur)="onSubmit()" [attr.disabled]="true" ngbTooltip="Agregar detalle de bultos en la siguiente sección" />
							<div *ngIf="localForm.touched && !isLocalService && exportFormGroup.controls.totalBultos.invalid" class="text-danger">
								<div *ngIf="exportFormGroup.controls.totalBultos.errors?.required">Campo Requerido</div>
							</div>
						</div>
						<!-- <div class="col-4 label-control">Unidad de Peso Bruto</div>
                        <div class="col-8">
                            <ng-select 
                            formControlName="medidaPesoBruto" 
                            [items]="unidadesMedidaSource"
                            [multiple]="false"
                            [clearable]="false"
                            (blur)="onSubmit()"
                            bindLabel="nombreUnidadMedida"></ng-select>
                            <div *ngIf="localForm.touched && exportFormGroup.controls.medidaPesoBruto.invalid" class="text-danger">
                                <div *ngIf="exportFormGroup.controls.medidaPesoBruto.errors?.required">Campo Requerido</div>
                            </div>
                        </div> -->
					</div>
				</div>
			</div>
			<div class="row">
				<!-- <div class="col-6 form-group mx-auto">
                    <div class="row">
                        <div class="col-4 label-control">Tipo de Bulto</div>
                        <div class="col-8">
                            <ng-select 
                                formControlName="tipoBulto" 
                                [items]="bultoSource"
                                [multiple]="false"
                                [clearable]="false"
                                (blur)="onSubmit()"></ng-select>
                        </div>
                    </div>
                </div> -->
				<!-- <div class="col-6 form-group">
                    <div class="row">
                        <div class="col-4 label-control">Total de Bultos</div>
                        <div class="col-8">
                            <input formControlName="totalBultos" type="text" class="form-control" (blur)="onSubmit()">
                            <div *ngIf="localForm.touched && exportFormGroup.controls.totalBultos.invalid" class="text-danger">
                                <div *ngIf="exportFormGroup.controls.totalBultos.errors?.required">Campo Requerido</div>
                            </div>
                        </div>
                    </div>
                </div> -->
			</div>
		</div>
	</div>
</div>
<div class="card card-custom mt-5">
	<div class="card-header">
		<div class="card-title">
			<p class="mb-0">Bultos</p>
		</div>
	</div>
	<div class="card-body p-0">
		<app-packages-list (packageListEmitter)="getPackagesList($event)"></app-packages-list>
	</div>
</div>
